/* eslint-disable no-unused-vars */
import { QuestionFormField, QuestionFormFieldType } from './questionFormField'

/**
 * Creates an instance of StarRatingField.
 * @typedef {Object} StarRatingFieldType
 * @property {?number} starCount
 *
 * @typedef {QuestionFormFieldType & StarRatingFieldType} StarRatingFieldExtendType
 */

/**
 * Represents a star rating form field.
 * @class
 */
export class StarRatingField extends QuestionFormField {
  /**
   * Create a new StarRatingField.
   * @param {StarRatingFieldExtendType} params
   */
  constructor(params) {
    super(params)
    this.starCount = params.starCount
  }
}
